<div class="container">
  <form #contactForm="ngForm">
    <div class="full-grid-tile">

    </div>
  </form>
</div>
